import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private userType = new BehaviorSubject(0);
  currentType = this.userType.asObservable();

  constructor() { }

  setUserType(type: number) {
    this.userType.next(type);
  }
}
